// extracted by mini-css-extract-plugin
export default {"headerContainer":"edit-team_headerContainer__XTYZ9","backIconWrapper":"edit-team_backIconWrapper__HCSkz","backIcon":"edit-team_backIcon__k5bmp"};